import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import _ from 'lodash'
import { BootstrapTable, TableHeaderColumn, SearchField } from 'react-bootstrap-table'
import DatePicker from 'react-datepicker';
import moment from 'moment';

import Header from './../../components/Header';
import StatisticsTiles from './../../components/Statistics/StatisticsTiles';
import Subheader from './../../components/Subheader';
import Footer from './../../components/Footer';
import Select from 'react-select';

class StatisticsPage extends PureComponent {

    constructor(props) {
        super(props);
        autobind(this);

        this.state = {
            currentDomain: null,
            domains: [],
            category: { value: 'all', label: 'All categories' },
            actionTypeOptions: [],
            actionType: { value: 'all', label: 'All action' },
            startDate: moment().subtract(1, 'month'),
            endDate: moment(),
            activeChart: 'week'
        }
    }

    componentDidMount() {

        const { subscriptions } = this.props
        const domains = _.map(subscriptions, (subscription, index) => {
            return subscription.domain
        }).filter((domain) => {
            return domain.constant !== 'NOTIFICATIONS'
        }).sort((a, b) => a.sortIndex - b.sortIndex).map((d,index) => Object.assign(d,{active:index === 0}))

        const firstDomain = domains[0];
        this.setState({
            domains,
            currentDomain: firstDomain
        })
        
        this.props.getLogStatistics({
            domain: firstDomain.constant
        })
        this.props.getUserStatistics()
        this.props.getCategories(firstDomain.constant)
        this.props.getLogTypes()

    }

    getOptions(newOptions = {}, removeOptions = []) {
        let options = {}
        if (this.state.currentDomain) {
            options['domain'] = this.state.currentDomain.constant
        }
        if (this.state.category && this.state.category.value !== 'all') {
            options['category'] = this.state.category.value;
        }
        if (this.state.actionType && this.state.actionType.value !== 'all') {
            options['actionType'] = this.state.actionType.value
        }
        if (this.state.startDate) {
            options['startAt'] = this.state.startDate.format('YYYY-MM-DD')
        }
        if (this.state.endDate) {
            options['endAt'] = this.state.endDate.format('YYYY-MM-DD')
        }
        return _.omit(Object.assign({}, options, newOptions), removeOptions)
    }

    updateCategory(selectedCategory) {
        this.setState({
            category: selectedCategory
        });
    }

    updateActionType(selectedActionType) {
        this.setState({
            actionType: selectedActionType
        });
    }

    onStartDateChange(date) {
        this.setState({
            startDate: date
        })
    }

    onEndDateChange(date) {
        this.setState({
            endDate: date
        })
    }

    renderChart(data) {
        let yAxisMax = 5;

        if(data && data.length) {
            yAxisMax = _.maxBy(data, ds => ds[1])[1]
        }
        yAxisMax *= 2

        let yAxisTickSize = 1
        if(5 <= yAxisMax && yAxisMax < 10) {
            yAxisTickSize = 2
        }else if(10 <= yAxisMax && yAxisMax < 50){
            yAxisTickSize = 5
        }else if(50 <= yAxisMax && yAxisMax < 100){
            yAxisTickSize = 10
        }else if(100 <= yAxisMax && yAxisMax < 500){
            yAxisTickSize = 50
        }else if(500 <= yAxisMax && yAxisMax < 1000){
            yAxisTickSize = 100
        }else if(1000 <= yAxisMax && yAxisMax < 5000){
            yAxisTickSize = 500
        }else if(5000 <= yAxisMax && yAxisMax < 10000){
            yAxisTickSize = 1000
        }else if(10000 <= yAxisMax && yAxisMax < 50000){
            yAxisTickSize = 5000
        }else if(50000 <= yAxisMax && yAxisMax < 100000){
            yAxisTickSize = 10000
        }else if(100000 <= yAxisMax && yAxisMax < 500000){
            yAxisTickSize = 50000
        }else if(500000 <= yAxisMax && yAxisMax < 1000000){
            yAxisTickSize = 100000
        }

        if (window.$("#actions-chart").length && data) {
            window.$.plot(window.$("#actions-chart"), [{
                data: data,
                label: "Page Views"
            }
            ], {
                    series: {
                        lines: {
                            show: true,
                            lineWidth: 2,
                            fill: true,
                            fillColor: {
                                colors: [{
                                    opacity: 0.25
                                }, {
                                    opacity: 0.25
                                }
                                ]
                            }
                        },
                        points: {
                            show: true,
                            radius: 5,
                            lineWidth: 3
                        },
                        shadowSize: 0
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        margin: {
                            left: 23,
                            right: 30,
                            top: 20,
                            botttom: 40
                        },
                        labelMargin: 15,
                        axisMargin: 500,
                        hoverable: true,
                        clickable: true,
                        tickColor: "rgba(0,0,0,0.05)",
                        borderWidth: 0
                    },
                    colors: ['#2CC185'],
                    xaxis: {
                        ticks: 11,
                        tickDecimals: 0
                    },
                    yaxis: {
                        ticks: 5,
                        max: yAxisMax,
                        min:0,
                        tickSize: yAxisTickSize,
                        tickDecimals: 0
                    }
                });
        }

    }

    generateStatistics() {
        this.props.getLogStatistics(this.getOptions())
    }

    priceFormatter(cell, row) {
        return '<i className="glyphicon glyphicon-usd"></i> ' + cell;
    }

    renderShowsTotal(start, to, total) {
        return (
            <p>Showing {start} to {to} of {total} entries</p>
        );
    }

    createCustomSearchField = (props) => {
        return (
            <SearchField
                className='form-control form-control-sm'
                style={{ display: 'inline-block' }}
                defaultValue=''
                placeholder='' />
        );
    }

    changeDomain = (domain, e) => {
        e.preventDefault()
        this.setState({
            currentDomain: domain,
            category: { value: 'all', label: 'All categories' }
        })
        this.props.getUserStatistics()
        this.props.getLogStatistics(this.getOptions({ domain: domain.constant }, ['category']))
        this.props.getCategories(domain.constant)
    }

    createCustomToolBar = props => {
        return (
            <div style={{ margin: 15, width: '100%' }} className="d-flex justify-content-between justify-content-center">
                <div className='col-6 d-flex align-items-center'>
                    {/* {props.components.btnGroup} */}
                    <h5 className="mb-0">Users ({this.props.logList.length})</h5>
                </div>
                <div className='col-6 d-flex justify-content-end'>
                    {props.components.searchPanel}
                </div>
            </div>
        );
    }

    mapActionType(actionType) {
        switch (actionType) {
            case 'favourite':
                return 'Favourited'
            case 'shared':
                return 'Shared'
            case 'remove_favourite':
                return 'Unfavourited'
            case 'download_model':
                return 'Downloaded'
            case 'website_visit':
                return 'Visited website'
            case 'screenshot':
                return 'Screenshot'
            case 'view':
                return 'Viewed'
            default:
                return actionType
        }
    }

    switchWeek() {
        this.setState({
            activeChart: 'week'
        })
    }

    switchMonth() {
        this.setState({
            activeChart: 'month'
        })
    }

    switchYear() {
        this.setState({
            activeChart: 'year'
        })
    }

    onDownloadPdfClick() {
        this.props.downloadStatisticsFile(Object.assign({}, this.getOptions(), { export: true, exportType: 'pdf' }))
    }

    onDownloadCsvClick() {
        this.props.downloadStatisticsFile(Object.assign({}, this.getOptions(), { export: true, exportType: 'csv' }))
    }

    render() {

        const { logList, categories, logTypes, timeFrameWeek, timeFrameMonth, timeFrameYear, statistics } = this.props

        const logs = logList.map((log) => {
            return {
                user: log.profileName,
                action: this.mapActionType(log.actionType),
                date: log.createdAt
            }
        })

        let categoryOptions = categories.map((category) => {
            return {
                value: category._id,
                label: category.name
            }
        })
        categoryOptions.unshift({ value: 'all', label: 'All categories' })

        let actionTypeOptions = logTypes.map((logType) => {
            return {
                value: logType,
                label: this.mapActionType(logType)
            }
        })
        actionTypeOptions.unshift({ value: 'all', label: 'All actions' })

        switch (this.state.activeChart) {
            case 'week':
                this.renderChart(timeFrameWeek.data)
                break;
            case 'month':
                this.renderChart(timeFrameMonth.data)
                break;
            case 'year':
                this.renderChart(timeFrameYear.data)
                break;
            default:
                this.renderChart(timeFrameWeek.data)

        }

        const options = {
            page: 1,
            sizePerPageList: [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: 'All', value: logs.length
            }],
            sizePerPage: 6,
            pageStartIndex: 1,
            paginationSize: 3,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationShowsTotal: this.renderShowsTotal,
            paginationPosition: 'bottom',
            hideSizePerPage: true,
            toolBar: this.createCustomToolBar,
            searchField: this.createCustomSearchField,
            withFirstAndLast: false
        };


        const csvArgsObj = { ...this.getOptions(), export: true, exportType: "csv" }
            , csvArgsString = Object.keys(csvArgsObj).map(key => `${key}=${encodeURIComponent(csvArgsObj[key])}`).join('&')
            , csvUrl = require('./../../apiconfig').targetBaseUrl + '/api/web/statistics/main/report?' + csvArgsString
        const pdfArgsObj = { ...this.getOptions(), export: true, exportType: "pdf" }
            , pdfArgsString = Object.keys(pdfArgsObj).map(key => `${key}=${encodeURIComponent(pdfArgsObj[key])}`).join('&')
            , pdfUrl = require('./../../apiconfig').targetBaseUrl + '/api/web/statistics/main/report?' + pdfArgsString

        return <div>
            <Header />
            <Subheader search={false} breadcrumbs={["Statistics"]}/>
            <div className="stastistics-subheader">
                <div className="container mb-5">
                    <StatisticsTiles statistics={statistics} />
                </div>
            </div>
            <div className="container mt-5">
                <div className="mb-1 d-flex justify-content-between">
                    <div className="d-flex mb-1 align-items-end">
                        {/* <button className="btn btn-space btn-secondary btn-no-border btn-sm mb-0"><span className="s7-print"></span> Print</button> */}
                        <a href={pdfUrl} className={"btn btn-space btn-secondary btn-no-border btn-sm mb-0" + (!logs.length ? " disabled" : "")}><span className="s7-next-2"></span> Download PDF</a>
                        <a href={csvUrl} className={"btn btn-space btn-secondary btn-no-border btn-sm mb-0 rm-0" + (!logs.length ? " disabled" : "")}><span className="s7-next-2"></span> Export to CSV</a>
                    </div>
                </div>

                <div className="panel panel-default mb-1">
                    <div className="row table-filters-container">
                        <div className="col-5 table-filters">
                            <div className="row">
                                <div className="col-6">
                                    <Select
                                        className="advanced-select"
                                        value={this.state.category}
                                        onChange={this.updateCategory}
                                        options={categoryOptions}
                                    />
                                </div>
                                <div className="col-6">
                                    <Select
                                        className="advanced-select"
                                        value={this.state.actionType}
                                        onChange={this.updateActionType}
                                        options={actionTypeOptions}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-5 table-filters">
                            <div className="row">
                                <div className="col-6">
                                    <DatePicker
                                        onChange={this.onStartDateChange}
                                        selected={this.state.startDate}
                                        dateFormat="DD/MM/YYYY"
                                    />
                                </div>
                                <div className="col-6">
                                    <DatePicker
                                        onChange={this.onEndDateChange}
                                        selected={this.state.endDate}
                                        dateFormat="DD/MM/YYYY"
                                    /></div>
                            </div>
                        </div>
                        <div className="col-2 table-filters">
                            <div className="d-flex justify-content-end">
                                <button className="btn btn-space btn-primary mb-0" onClick={this.generateStatistics}>Generate</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row xs-gutters">
                    <div className="col-5">
                        <div className="widget widget-fullwidth">
                            <div className="widget-chart-container">
                                <div id="actions-chart" style={{ height: 220, width: 470, position: 'relative' }}></div>
                                <div className="chart-table pt-3">
                                    <table className="table table-striped action-statistics-table">
                                        <thead className="primary text-center">
                                            <tr>
                                                <th>Actions</th>
                                                <th className="number" onClick={this.switchWeek}>Week</th>
                                                <th className="number" onClick={this.switchMonth}>Month</th>
                                                <th className="number" onClick={this.switchYear}>Year</th>
                                            </tr>
                                        </thead>
                                        <tbody className="no-border-x text-center">
                                            <tr>
                                                <td>Total</td>
                                                <td className={'number ' + (this.state.activeChart === 'week' ? 'active' : '')} onClick={this.switchWeek}>{timeFrameWeek.overallActions}</td>
                                                <td className={'number ' + (this.state.activeChart === 'month' ? 'active' : '')} onClick={this.switchMonth}>{timeFrameMonth.overallActions}</td>
                                                <td className={'number ' + (this.state.activeChart === 'year' ? 'active' : '')} onClick={this.switchYear}>{timeFrameYear.overallActions}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-7">
                        {logs && logs.length ? (
                            <BootstrapTable options={options} pagination={true} data={logs} striped={false} hover={true} bordered={false} search>
                                <TableHeaderColumn dataField="user" isKey={true} dataSort={true}>User</TableHeaderColumn>
                                <TableHeaderColumn dataField="action" dataSort={true}>Action</TableHeaderColumn>
                                <TableHeaderColumn dataField="date" dataFormat={this.priceFormatter}>Date</TableHeaderColumn>
                            </BootstrapTable>) : (<p className="mt-3 ml-3">No actions were found based on this search.</p>)}
                    </div>
                </div>
            </div>

            <Footer />
        </div>;
    }

}

export default connect(
    (state, ownProps) => {
        const {
            userStatus: { subscriptions },
            statistics: { statistics, logStatistics, logList, logTypes, timeFrameDay, timeFrameWeek, timeFrameMonth, timeFrameYear },
            getCategories: { categories } } = state
        return { subscriptions, statistics, logStatistics, logList, logTypes, categories, timeFrameDay, timeFrameWeek, timeFrameMonth, timeFrameYear }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(withRouter(StatisticsPage))



// WEBPACK FOOTER //
// ./src/containers/Statistics/Statistics.js